import { render, staticRenderFns } from "./personalIndex.vue?vue&type=template&id=4fbd5f77&scoped=true&"
import script from "./personalIndex.vue?vue&type=script&lang=js&"
export * from "./personalIndex.vue?vue&type=script&lang=js&"
import style0 from "./personalIndex.vue?vue&type=style&index=0&id=4fbd5f77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbd5f77",
  null
  
)

export default component.exports